module.exports = "<p>Picking</p>\r\n<mat-tab-group>\r\n  <mat-tab *ngFor=\"let tab of SettingsTab\" label=\"{{tab}}\"></mat-tab>\r\n</mat-tab-group>"